const maskCpf = '000.000.000-00';

const documentMask = (value: string): string => {
  const onlyNumbers = value.replace(/\D/g, '');
  const limitedNumbers = onlyNumbers.slice(0, 11);
  let maskedValue = '';
  let maskIndex = 0;

  for (let i = 0; i < limitedNumbers.length; i++) {
    if (/\D/.test(maskCpf[maskIndex])) {
      maskedValue += maskCpf[maskIndex];
      maskIndex++;
    }

    maskedValue += limitedNumbers[i];
    maskIndex++;
  }

  return maskedValue;
};

const maskEmail = (email: string): string => {
  const [localPart, domain] = email.split('@');

  if (!localPart || !domain) {
    throw new Error('Invalid email format');
  }

  let visiblePart = '';
  if (localPart.length >= 4) {
    visiblePart = localPart.substring(0, 4);
  } else {
    visiblePart = localPart.substring(0, 2);
  }

  const maskedPart = '******';
  return `${visiblePart}${maskedPart}@${domain}`;
};

const maskValue = (value: string): string => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (value.includes('@')) {
    if (!emailPattern.test(value)) {
      throw new Error('Invalid email format');
    }
    return maskEmail(value);
  }
  return documentMask(value);
};

export default maskValue;
export { documentMask, maskEmail };
